import React from 'react';

import { Box, ComposableTypography, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';
import { Letter } from '@icons';

import { useChangeEmailHelper } from './changeEmail.helper';

export const ChangeEmail: React.FC = () => {
	const { resources, titleLabel } = useChangeEmailHelper();

	return (
		<Box
			styles={{
				flexDirection: 'column',
			}}
		>
			<Box
				styles={{
					width: '100%',
					flexDirection: 'row',
					padding: rem(24),
					borderRadius: rem(16),
					backgroundColor: 'white',
					filter: 'drop-shadow(0px 2px 4px #E8EDF2)',
				}}
			>
				<Box>
					<Box styles={{ padding: rem(12, 8) }}>
						<Letter />
					</Box>
					<Box
						styles={{
							flexDirection: 'column',
							justifyContent: 'flex-start',
							marginLeft: rem(16),
						}}
					>
						<Box>
							<Typography appearance="body-100-04">{titleLabel}</Typography>
						</Box>
						<Spacer vertical={8} />
						<Box>
							<ComposableTypography
								text={resources.description}
								baseProps={{
									appearance: 'body-75-02',
								}}
								tags={{
									b: { appearance: 'body-75-04' },
								}}
							/>
						</Box>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
